import { render, staticRenderFns } from "./s-newInfo.vue?vue&type=template&id=0f4bf27e&scoped=true&"
import script from "./s-newInfo.vue?vue&type=script&lang=js&"
export * from "./s-newInfo.vue?vue&type=script&lang=js&"
import style0 from "./s-newInfo.vue?vue&type=style&index=0&id=0f4bf27e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4bf27e",
  null
  
)

export default component.exports